import { DeviceTypes } from "../apiTypes";

export const deviceLinkLocalhostRoot = 'http://localhost:53211/api/v1';

export interface About {
    machineName: string;
    operatingSystem: string;
    architecture: string;
    framework: string;
    timeZone: string;
    utcOffset: string;
    serviceName: string;
    vendor: string;
    connection: string;
    version: string;
    isUpdatePending: boolean;
    environment: string;
    status: string;
}

export interface Update {
    id: string;
    version: string;
    fileSize: number;
    isDelta: boolean;
}

export interface Device {
    id: string;
    type: DeviceTypes;
    name: string;
    vendor: string;
    hardware: string;
    firmware: string;
    serial: string;
    connection: string;
    status: string;
}

export interface IsSuccessResult {
    isSuccess: boolean;
}

export const ApiAbout = (): Promise<About> => {
    return fetch(`${deviceLinkLocalhostRoot}/about`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
    .then(response => response.json())
}

export const ApiUpdates = (): Promise<Update> => {
    return fetch(`${deviceLinkLocalhostRoot}/updates`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}

export const ApiUpdatesApply = (): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/updates/apply`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.ok);
}

export const ApiDevices = (): Promise<Array<Device>> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}
